import React from 'react'
import classNames from 'classnames'

export interface FilterProps {
  text: string
  className?: string
  selected: boolean
  onClick: () => void
}

const TagFilter = ({ text, className, selected, onClick }: FilterProps) => {
  return (
    <button
      className={classNames('c-pill', className, { 't-black u-color-white': selected })}
      onClick={onClick}>
      <span>{text}</span>
    </button>
  )
}

export default TagFilter
